export default __webpack_public_path__ + "static/media/vinay.fe0acfbd.jpeg";